import React, { useState } from 'react';

const Quiz = () => {
  const [questions, setQuestions] = useState([
    { id: 1, image: 'https://ik.imagekit.io/growthx100/DIANA-FINAL-LOGO-1-svg%20(2).svg?updatedAt=1712596600568', answer: '', options: ['Option 1', 'Option 2', 'Option 3'] },
    { id: 2, image: 'https://ik.imagekit.io/growthx100/DIANA-FINAL-LOGO-1-svg%20(2).svg?updatedAt=1712596600568', answer: '', options: ['Option 4', 'Option 5', 'Option 6'] },
    { id: 3, image: 'https://ik.imagekit.io/growthx100/DIANA-FINAL-LOGO-1-svg%20(2).svg?updatedAt=1712596600568', answer: '', options: ['Option 7', 'Option 8', 'Option 9'] },
    { id: 4, image: 'https://ik.imagekit.io/growthx100/DIANA-FINAL-LOGO-1-svg%20(2).svg?updatedAt=1712596600568', answer: '', options: ['Option 10', 'Option 11', 'Option 12'] },
    { id: 5, image: 'https://ik.imagekit.io/growthx100/DIANA-FINAL-LOGO-1-svg%20(2).svg?updatedAt=1712596600568', answer: '', options: ['Option 13', 'Option 14', 'Option 15'] }
  ]);
  const [draggedOption, setDraggedOption] = useState(null);

  const handleDragStart = (e, option) =>  {
    setDraggedOption(option);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e, questionId) => {
    const updatedQuestions = questions.map((question) => {
      if (question.id === questionId) {
        return { ...question, answer: draggedOption, options: question.options.filter((option) => option !== draggedOption) };
      }
      return question;
    });
    setQuestions(updatedQuestions);
    setDraggedOption(null);
  };

  const handleRemoveOption = (questionId) => {
    const updatedQuestions = questions.map((question) => {
      if (question.id === questionId) {
        const removedOption = question.answer;
        const updatedOptions = [...question.options, removedOption].sort();
        return { ...question, answer: '', options: updatedOptions };
      }
      return question;
    });
    setQuestions(updatedQuestions);
  };

  const handleSubmit = () => {
    const correctAnswers = questions.filter((question) => question.answer === question.options[0]).length;
    const wrongAnswers = questions.length - correctAnswers;
    alert(`Correct Answers: ${correctAnswers}, Wrong Answers: ${wrongAnswers}`);
  };

  return (
    <div className="container mx-auto py-8">
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {questions.map((question) => (
          <div key={question.id} className="bg-white rounded-lg shadow-md p-4">
            <img src={question.image} alt={`Question ${question.id}`} className="w-full h-auto mb-4" />
            <div
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, question.id)}
              className="border border-gray-300 p-2 h-12 flex items-center justify-between rounded-md mb-4 relative"
            >
              {question.answer || 'Drop here'}
              {question.answer && (
                <button
                  onClick={() => handleRemoveOption(question.id)}
                  className="text-red-500 hover:text-red-700 focus:outline-none"
                >
                  &times;
                </button>
              )}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-8">
        <div className="flex flex-wrap justify-center">
          {questions.flatMap((question) =>
            question.options.map((option) => (
              <div
                key={`${question.id}-${option}`}
                draggable
                onDragStart={(e) => handleDragStart(e, option)}
                className="bg-gray-200 rounded-md py-2 px-4 m-2 cursor-move"
              >
                {option}
              </div>
            ))
          )}
        </div>
        <button
          onClick={handleSubmit}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mt-4"
        >
          Submit
        </button>
      </div>
    </div>
  );
};

export default Quiz;